module.exports = __webpack_public_path__ + "static/media/fire.e5fbf8e0.png";